import { ImageModel } from '../../domain/models'

export function getImage (image: ImageModel, isNull?: boolean) : string|null {
  if (image !== null && image !== undefined) {
    return image.url
  }
  return isNull ? null : '/images/no-image.jpg'
}
